<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="far fa-building" class="q-mb-sm" /> {{ $t('branches') }}
        </div>

        <filters class="filter-card" :options="getOptionsFilter" @requestFiltered="requestFiltered" @clearAndRequest="clearAndRequest"/>

        <q-table
            :data="branches"
            :columns="visibleColumns"
            :pagination.sync="server_pagination"
            @request="request"
            :loading="loading"
            :filter="filter"
            row-key="name"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[5,10,50,100]"
            binary-state-sort
            >

            <template slot="top" slot-scope="props">
                <q-search v-model="filter" :debounce="600" icon="fas fa-search" :placeholder="$t('search')" />
                <div class="col" />

                <!-- <q-btn color="secondary" v-if="reportsPermission" icon="fas fa-download" class="q-mr-sm" :label="$t('stores_reports')" @click="downloadReport()" /> -->
                <q-btn color="secondary" icon="fas fa-plus" :label="$t('new')" @click="$router.push({ name: 'admin_branch', params: { id: 0 } })" />
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td auto-width key="id" :props="props">
                    {{ props.row.id }}
                </q-td>

                <q-td key="name" :props="props">
                    {{ props.row.name }}
                </q-td>

                <q-td key="fantasy" :props="props">
                    {{ props.row.fantasy }}
                </q-td>

                <q-td key="document" :props="props">
                    {{ props.row.document }}
                </q-td>

                <q-td key="register" :props="props">
                    {{ props.row.register }}
                </q-td>

                <q-td key="company" :props="props">
                    {{ props.row.company }}
                </q-td>

                <q-td key="branch_type" :props="props">
                    {{ getBranchType(props.row.branch_type) }}
                </q-td>

                <q-td v-if="hasBranchCategory" key="branch_size_type" :props="props">
                    {{ props.row.branch_size_type_label }}
                </q-td>

                <q-td key="managers" :props="props">
                    <q-btn
                        color="primary"
                        text-color="white"
                        :label="(props.row.managers ||
                                props.row.managers_regional ||
                                props.row.managers_general) && props.row.managers.length + props.row.managers_regional.length + props.row.managers_general.length"
                        no-ripple>
                        <q-tooltip v-if="(props.row.managers ||
                                props.row.managers_regional ||
                                props.row.managers_general) && (props.row.managers.length || props.row.managers_regional.length || props.row.managers_general.length)">
                            <p class="tooltip q-mb-sm">
                                <div v-if="props.row.managers && props.row.managers.length">
                                    {{ $t('managers') }}:
                                    <span v-for="(manager, index) in props.row.managers" :key="index">
                                        {{ manager.full_name }}
                                        <span v-if="(props.row.managers.length - 1) > index">, </span>
                                    </span>
                                </div>
                                <div v-if="props.row.managers_regional && props.row.managers_regional.length">
                                    {{ $t('managers_regional') }}:
                                    <span v-for="(manager, index) in props.row.managers_regional" :key="index">
                                        {{ manager.full_name }}
                                        <span v-if="(props.row.managers_regional.length - 1) > index">, </span>
                                    </span>
                                </div>
                                <div v-if="props.row.managers_general && props.row.managers_general.length">
                                    {{ $t('managers_general') }}:
                                    <span v-for="(manager, index) in props.row.managers_general" :key="index">
                                        {{ manager.full_name }}
                                        <span v-if="(props.row.managers_general.length - 1) > index">, </span>
                                    </span>
                                </div>
                            </p>
                        </q-tooltip>
                    </q-btn>
                </q-td>

                <q-td key="status" :props="props" auto-width>
                    <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" class="full-width">
                        {{ $t(getStatus(props.row.status)) }}
                    </q-chip>
                </q-td>

                <q-td key="actions" :props="props">
                    <q-btn flat round color="primary" icon="fas fa-pencil-alt" @click="$router.push({ name: 'admin_branch', params: { id: props.row.actions } })" >
                        <q-tooltip>
                            {{ $t('view_or_edit_tooltip')}}
                        </q-tooltip>
                    </q-btn>
                    <q-btn flat round color="negative" icon="far fa-trash-alt" @click="confirmRemove(props.row.actions)" >
                        <q-tooltip>
                            {{ $t('delete_tooltip')}}
                        </q-tooltip>
                    </q-btn>
                </q-td>
            </q-tr>
        </q-table>

        <q-dialog v-model="confirm_remove" @ok="removeItem">
            <span slot="title">{{ $t('remove_item') }}</span>

            <span slot="message">{{ $t('confirm_remove_item') }}</span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="primary" :label="$t('cancel')" @click="confirm_remove = false" />
                <q-btn color="negative" :label="$t('remove')" @click="removeItem()" />
            </template>
        </q-dialog>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { LocalStorage } from 'quasar'
import BranchFilters from 'components/admin/organization/BranchFilters'
export default {
    i18nOptions: { namespaces: [ 'custom', 'common', 'organization', 'imports'] },

    data() {
        return {
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            loading: false,
            branches: [],
            columns: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'name',
                    sortable: true,
                },
                {
                    name: 'name',
                    required: true,
                    label: 'name',
                    align: 'left',
                    field: 'name',
                    sortable: true,
                },
                {
                    name: 'fantasy',
                    required: true,
                    label: 'name_fantasy',
                    align: 'left',
                    field: 'fantasy',
                    sortable: true,
                },
                {
                    name: 'document',
                    required: true,
                    label: 'store_document',
                    align: 'left',
                    field: 'document',
                    sortable: true,
                },
                {
                    name: 'register',
                    required: true,
                    label: 'register_number',
                    align: 'left',
                    field: 'register',
                    sortable: true,
                },
                {
                    name: 'company',
                    required: true,
                    label: 'headquarter',
                    align: 'left',
                    field: 'company',
                    sortable: true,
                },
                {
                    name: 'branch_type',
                    required: true,
                    label: 'branch_type',
                    align: 'left',
                    field: 'branch_type',
                    sortable: true,
                },
                {
                    name: 'branch_size_type',
                    required: true,
                    label: 'branch_size_types',
                    align: 'left',
                    field: 'branch_size_type_label',
                    sortable: false,
                },
                {
                    name: 'managers',
                    required: true,
                    label: 'managers',
                    align: 'center',
                    field: 'managers',
                    sortable: false,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'center',
                    field: 'status',
                    sortable: true,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'right',
                    field: 'edit',
                    sortable: false,
                },
            ],
            filter: '',
            status: [],
            branch_type: [],
            company: [],
            managers: [],
            action_id: '',
            confirm_remove: false
        }
    },

    components: {
        'filters': BranchFilters
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            branch_types: 'registration_lists/branch_types',
            clients_params: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
            num_rows: 'datatable/num_rows',
            user_client_module_items: 'common/user_client_module_items',
        }),

        hasBranchCategory() {
            const clientParams = this.clients_params.find((obj) => String(obj.id) === String(this.id_user_client_selected))
            return !!clientParams && clientParams.has_branch_category === true
        },

        visibleColumns() {
            return this.columns.filter(column => column.name !== 'branch_size_type' || this.hasBranchCategory)
        },

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getOptionsFilter() {
            return {
                branch_types: this.branch_types ? this.branch_types : [],
                statuses: [
                    { value: 1, label: this.$t('active_f') },
                    { value: 2, label: this.$t('inactive_f') },
                    { value: 3, label: this.$t('deleted_f') },
                    { value: 4, label: this.$t('pending') }
                ]
            }
        },

        reportsPermission() {
            let obj = this.user_client_module_items.find((obj) => { return obj.id === this.id_user_client_selected })
            if (obj) {
                let item = obj.module_items.find((obj) => obj.slug === "reports")
                if(item) return item.permission
            } else return false
        },
    },

    methods: {
        fetchLists() {
            this.$q.loading.show()

            this.$axios.get('/accounts/get_registration_lists/', this.getHeader)
            .then(response => {
                this.$store.dispatch('registration_lists/SET_LISTS', [response.data])
                this.$q.loading.hide()

                this.request({
                    pagination: this.server_pagination
                })
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        request ({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "search": this.filter,
                "ordering": order_by
            }

            if (this.status.length) {
                data.status = this.status
            }

            if (this.branch_type.length) {
                data.branch_type = this.branch_type
            }

            if (this.company.length) {
                data.company = this.company
            }

            if (this.managers.length) {
                data.managers__id = this.managers
            }

            this.savePagination()

            this.$axios.get(`/admin_companies/branches/?${this.$qs.stringify(data, { arrayFormat: 'repeat' })}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count

                this.branches = response.data.results.map(e => {
                    return {
                        ...e,
                        company: e.branch_company ? e.branch_company.name : '',
                        actions: e.id }
                })

                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        confirmRemove(id) {
            this.action_id = id
            this.confirm_remove = true
        },

        removeItem() {
            this.$q.loading.show()

            this.$axios.delete(`/admin_companies/branches/${this.action_id}/`, this.getHeader)
            .then(response => {
                this.$q.loading.hide()

                this.request({
                    pagination: this.server_pagination
                })

                this.confirm_remove = false

                this.$q.notify({
                    message: this.$t('item_removed_success'),
                    type: 'positive',
                    icon: 'far fa-trash-alt'
                })
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        downloadReport() {
            let message = this.$t('generating_import_file_message')
            this.$q.loading.show({
                message
            })

            let data = {
                "search": this.filter,
                "status": this.status,
                "branch_type": this.branch_type,
            }

            this.$axios.get(`admin_users/users/generate_report/?${this.$qs.stringify(data, { arrayFormat: 'repeat' })}`, this.getHeader)
            .then(response => {
                this.forceFileDownload(response.data.path_url)
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
            .finally(() =>{
                this.$q.loading.hide()
            })
        },

        forceFileDownload(response){
			const link = document.createElement('a')
			link.href = response
			document.body.appendChild(link)
			link.click()
        },

        getStatus(status) {
            if (status == 1) return 'active_f'
            else if (status == 2) return 'inactive_f'
            else if (status == 3) return 'deleted_f'
            else if (status == 4) return 'pending'
        },

        getIconStatus(status) {
            if (status == 1) return 'fas fa-check'
            else if (status == 2) return 'fas fa-ban'
            else if (status == 3) return 'fas fa-trash-alt'
            else if (status == 4) return 'fas fa-clock'
        },

        getColorStatus(status) {
            if (status == 1) return 'positive'
            else if (status == 2) return 'warning'
            else if (status == 3) return 'negative'
            else if (status == 4) return 'warning'
        },

        getBranchType(id) {
            let branch_type = this.branch_types.find((obj) => { return obj.value === id })
            if (branch_type) return branch_type.label
            else return ''
        },

        requestFiltered({ status, branch_type, company, manager }) {
            this.status      = status
            this.branch_type = branch_type
            this.company = company
            this.managers = manager

            this.request({ pagination: { page: 1, rowsNumber: 10, rowsPerPage: this.num_rows, descending: false, sortBy: null } })
        },

        clearAndRequest() {
            this.status           = []
            this.branch_type      = []
            this.company          = []
            this.managers          = []

            this.request({ pagination: { page: 1, rowsNumber: 10, rowsPerPage: this.num_rows, descending: false, sortBy: null } })
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        }
    },

    created() {
        this.loadPagination()
        this.fetchLists()
    }
}
</script>

<style lang="stylus" scoped>
.filter-card
    border-radius 4px
    box-shadow 0 1px 2px rgba(0,0,0,0.2), 0 1px 1px rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12)
</style>
